import type { MenuConfig } from '~typings/menu'

import permisosPresupuesto, { RESOURCE_PRESUPUESTO } from '@/auth/permissions/modules/presupuesto'
import * as routes from '@routes/presupuesto/nombres/mantenimiento'

const { mantenimiento } = permisosPresupuesto
export default [
    {
        title: 'presupuesto.subopciones.bandeja_plantillas',
        action: mantenimiento.bandejaPlantillas,
        resource: RESOURCE_PRESUPUESTO,
        route: routes.ROUTE_BANDEJA,
    },
    {
        title: 'presupuesto.subopciones.ver_plantilla',
        action: mantenimiento.plantillaPresupuesto,
        resource: RESOURCE_PRESUPUESTO,
        route: routes.ROUTE_PLANTILLA_PRESUPUESTO,
    },
] as MenuConfig[]
